module.exports = __webpack_public_path__ + "img/semitrailerRearLeft.0a485395.svg";